export default function AppSupport() {
  return (
    <div
      style={{
        height: '100vh',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        background: '#030a0f',
      }}
    >
    <div
      style={{
        maxWidth: 720,
        margin: '0 auto',
        padding: '48px 24px 80px',
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
        fontSize: 16,
        lineHeight: 1.7,
        color: '#d1d5db',
      }}
    >
      <h1 style={{ color: '#fff', fontSize: 28, fontWeight: 700, marginBottom: 8 }}>Support</h1>
      <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 40 }}>
        Operator App by Parallax Pictures
      </p>

      <div
        style={{
          background: '#0f1a24',
          border: '1px solid #1f2937',
          borderRadius: 8,
          padding: '16px 20px',
          marginBottom: 16,
        }}
      >
        <p style={{ margin: 0 }}>
          Operator is the mobile companion for the Matrix sports photography platform. If you need
          help or have questions, we are here to assist.
        </p>
      </div>

      <h2 style={styles.h2}>Getting Started</h2>
      <p>
        To use Operator, you need access to a Matrix Operator server provided by your organization.
        Open the app, add your server environment, and sign in with your credentials.
      </p>

      <h2 style={styles.h2}>Common Questions</h2>
      <ul style={{ marginBottom: 14, paddingLeft: 24 }}>
        <li style={{ marginBottom: 6 }}>
          <strong>Cannot connect to server</strong> -- Verify the server URL is correct and that you
          have network access. The URL should start with https://.
        </li>
        <li style={{ marginBottom: 6 }}>
          <strong>Login fails</strong> -- Check your username and password. Contact your
          organization&apos;s administrator if you need your credentials reset.
        </li>
        <li style={{ marginBottom: 6 }}>
          <strong>Photos not loading</strong> -- Ensure you have a stable connection to your Matrix
          server. Pull down to refresh the photo grid.
        </li>
        <li style={{ marginBottom: 6 }}>
          <strong>Edits not saving</strong> -- Check the sync indicator in the app. Pending changes
          will be synced automatically when connectivity is restored.
        </li>
      </ul>

      <h2 style={styles.h2}>Contact Us</h2>
      <p>For technical support, bug reports, or feature requests, reach out to us directly.</p>

      <div
        style={{
          background: '#0f1a24',
          border: '1px solid #1f2937',
          borderRadius: 8,
          padding: 24,
          marginTop: 24,
        }}
      >
        <p
          style={{
            color: '#9ca3af',
            fontSize: 12,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            fontWeight: 600,
            marginBottom: 4,
          }}
        >
          Email
        </p>
        <p style={{ marginBottom: 0 }}>
          <a
            href="mailto:info@parallaxpictures.nl"
            style={{ color: '#60a5fa', textDecoration: 'none' }}
          >
            info@parallaxpictures.nl
          </a>
        </p>
      </div>

      <h2 style={styles.h2}>Privacy</h2>
      <p>
        Read our{' '}
        <a href="/app/privacy" style={{ color: '#60a5fa', textDecoration: 'none' }}>
          Privacy Policy
        </a>{' '}
        to learn how the app handles your data.
      </p>

      <div
        style={{
          marginTop: 48,
          paddingTop: 24,
          borderTop: '1px solid #1f2937',
          color: '#6b7280',
          fontSize: 13,
        }}
      >
        <p>&copy; 2026 Parallax Pictures. All rights reserved.</p>
      </div>
    </div>
    </div>
  );
}

const styles = {
  h2: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 600,
    marginTop: 40,
    marginBottom: 16,
    paddingBottom: 8,
    borderBottom: '1px solid #1f2937',
  },
};
